import {
  FILTERS_PAGE_SIZE,
  useAutoSelectDefaultFilters,
  useFilterPanelState
} from '../../../../controls/AnalyticsFilters/AnalyticsFilterPanel.hooks'
import AnalyticsFilters from '../../../../controls/AnalyticsFilters/AnalyticsFilters'
import { SelectedFilter } from '../../../../data/model/results'
import { useSurveyId } from '../../../../hooks/useSurveyId'
import { getSelectedFilterCount } from '../../../../utils/resultsUtils'
import { useAnalyticsFilters } from './AnalyticsFilters.hooks'

interface Props {
  selectedFilters: SelectedFilter[]
  setSelectedFilters: (selectedFilters: SelectedFilter[]) => void
  language?: string
  languageLoading?: boolean
}

export const AnalyticsResultsFilters = ({
  selectedFilters,
  setSelectedFilters,
  language,
  languageLoading
}: Props) => {
  const surveyId = useSurveyId()
  const {
    currentOffset,
    setCurrentOffset,
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery
  } = useFilterPanelState(language, selectedFilters)

  const {
    loading: loadingFilters,
    totalCount,
    filters,
    forkFilters,
    knownFilters,
    knownForkFilters,
    error
  } = useAnalyticsFilters({
    surveyId,
    search: debouncedSearchQuery,
    offset: currentOffset,
    limit: FILTERS_PAGE_SIZE,
    selectedFilters,
    language,
    languageLoading
  })

  useAutoSelectDefaultFilters(
    filters,
    forkFilters,
    selectedFilters,
    setSelectedFilters
  )

  // Show error state if API failed
  if (error) {
    return <div>Error loading filters</div>
  }

  return (
    <AnalyticsFilters
      isLoading={loadingFilters}
      filterCount={getSelectedFilterCount(selectedFilters)}
      filters={filters}
      forkFilters={forkFilters}
      knownFilters={knownFilters}
      knownForkFilters={knownForkFilters}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
      totalCount={totalCount}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      currentOffset={currentOffset}
      setCurrentOffset={setCurrentOffset}
      limit={FILTERS_PAGE_SIZE}
    />
  )
}
